import { Button, BoxProps, Icon } from "@xcorejs/ui";
import { FC } from "react";
import AudioVersionIcon from "components/icons/24/audio-version.svg";
import { useLayout } from "../xcore/index";

export const PodcastEpisodeButton: FC<BoxProps> = (props) => {
  const { general, stringify } = useLayout();

  return (
    <Button
      size="xs"
      variant="clear"
      borderRadius={0}
      padding="5px !important"
      as="a"
      display="flex"
      alignItems="center"
      whiteSpace="pre"
      {...props}
    >
      <Icon
        mr=".2rem"
        width="24px"
        height="24px"
        pt=".3rem"
        svg={<AudioVersionIcon />}
        fill="#e00034"
        _group={{
          _hover: {
            _icon: { fill: "#e00034" }
          }
        }}
      />

      {stringify(general.values.audioVersion)}
    </Button>
  );
};
